module.exports = __webpack_public_path__ + "static/media/logo-17@2x.a2d134c1.png";